import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { MasterBrandDto } from './master-brand-dto';


export class AllMasterBrandsResponseModel extends GlobalResponseObject {
    data?: MasterBrandDto[];
    
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data MasterBrandDTO[]
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: MasterBrandDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}